export const inputWidth = 'xl';
